/*
  Product-page delivery-time checker.

  TWO SEPARATE THINGS ARE MODELLED HERE

  1. COVERAGE (which countries a product can ship to) comes from this store's
     delivery profiles in Settings > Shipping and delivery. Each product sits in
     one profile and each profile covers a different country set, so the country
     list below is per profile. A country missing from a profile means checkout
     has no rate for it and would refuse the order.

  2. TRANSIT TIME comes from Stallion Express's published estimates, applied
     store-wide by destination (not per profile). These are estimates for the
     carrier leg only — they start when the parcel leaves the studio, AFTER the
     production lead time shown on the product page.

  Neither is a live feed: Liquid cannot read delivery profiles from the
  storefront. If shipping zones change, update COVERAGE. If the carrier revises
  its estimates, update TRANSIT. Checkout stays the authoritative source, which
  is why the wording says "estimated".
*/
(function () {
  var NAMES = {
    AE: 'United Arab Emirates', AT: 'Austria', AU: 'Australia', BE: 'Belgium',
    CA: 'Canada', CH: 'Switzerland', CL: 'Chile', CO: 'Colombia', CZ: 'Czechia',
    DE: 'Germany', DK: 'Denmark', ES: 'Spain', FI: 'Finland', FR: 'France',
    GB: 'United Kingdom', GR: 'Greece', HK: 'Hong Kong SAR', IE: 'Ireland',
    IL: 'Israel', IS: 'Iceland', IT: 'Italy', JP: 'Japan', KR: 'South Korea',
    MC: 'Monaco', MO: 'Macao SAR', MT: 'Malta', MX: 'Mexico', MY: 'Malaysia',
    NL: 'Netherlands', NO: 'Norway', NZ: 'New Zealand', PA: 'Panama',
    PH: 'Philippines', PL: 'Poland', PT: 'Portugal', RS: 'Serbia', SE: 'Sweden',
    SG: 'Singapore', SI: 'Slovenia', TH: 'Thailand', TW: 'Taiwan',
    US: 'United States', ZA: 'South Africa'
  };

  // Stallion Express transit estimates, business days after dispatch.
  var TRANSIT_DEFAULT = '10\u201325 business days';
  var TRANSIT = {};
  [
    [['CA'], '2\u20138 business days'],
    [['US'], '3\u20138 business days'],
    [['GB', 'IE'], '5\u201310 business days'],
    [['FR', 'DE', 'NL', 'BE'], '7\u201314 business days'],
    [['IT', 'ES', 'PT'], '8\u201316 business days'],
    [['DK', 'SE', 'FI'], '8\u201316 business days'],
    [['NO', 'IS', 'CH'], '8\u201318 business days'],
    [['MX'], '10\u201320 business days'],
    [['JP', 'HK', 'KR', 'SG'], '7\u201315 business days'],
    [['TW'], '8\u201318 business days'],
    [['AU', 'NZ'], '7\u201315 business days']
  ].forEach(function (pair) {
    pair[0].forEach(function (code) { TRANSIT[code] = pair[1]; });
  });

  var EU = ['AT','BE','CZ','DK','FI','FR','DE','GR','IS','IE','IL','IT','NL','NO','PL','PT','ES','SE','CH','AE','GB'];

  var COVERAGE = {
    general: ['CA','US','AE','AT','AU','BE','CH','CZ','DE','DK','ES','FI','FR','GB','HK','IE','IL','IT','JP','KR','MY','NL','NO','NZ','PL','PT','SE','SG','TW','GR','IS','MX'],

    smallkeychains: ['CA','US','HK','MY','SG','KR','TW','JP','TH','MO','AU','MC','ZA','CL','PH','RS','PA','MX','NZ','CO','MT'].concat(EU),

    pencilcase: ['CA','US','HK','MY','SG','KR','MX','AU','NZ','PH','RS','PA','JP','TW','TH','ZA','CL','MO','MT','MC','CO'].concat(EU),

    coinpurse: ['CA','US','HK','JP','MY','SG','KR','TW','TH','ZA','MO','AU','PH','RS','MX','NZ','CL','MT','PA','CO'].concat(EU),

    stingray: ['CA','US','AU','MC','ZA','CL','PH','RS','HK','JP','MY','MX','NZ','SG','KR','TW','TH','SI','MO','MT','PA','CO'].concat(EU),

    keypouch: ['CA','US','AU','MC','PH','RS','HK','JP','MY','MX','NZ','SG','KR','TW','TH','CL','MO','MT','PA','CO'].concat(EU),

    rudolph: ['CA','US','HK','JP','MY','SG','KR','TW','TH','AU','MX','MC','NZ','SI','ZA','CL','RS','MO','MT','PA','PH','CO'].concat(EU)
  };

  function transitFor(code) {
    return TRANSIT[code] || TRANSIT_DEFAULT;
  }

  if (!customElements.get('shipping-estimate')) {
    customElements.define('shipping-estimate', class extends HTMLElement {
      connectedCallback() {
        try {
          this.trigger = this.querySelector('.shipping-estimate__trigger');
          this.panel = this.querySelector('.shipping-estimate__panel');
          this.select = this.querySelector('.shipping-estimate__select');
          this.result = this.querySelector('.shipping-estimate__result');

          var codes = COVERAGE[this.dataset.profile] || COVERAGE.general;
          // Profiles are assembled from overlapping zone lists, so de-duplicate.
          this.codes = codes.filter(function (c, i) { return codes.indexOf(c) === i; });

          this.populate();
          this.trigger.addEventListener('click', this.toggle.bind(this));
          this.select.addEventListener('change', this.show.bind(this));
        } catch (e) {
          console.error('[shipping-estimate]', e);
        }
      }

      populate() {
        var frag = document.createDocumentFragment();
        this.codes
          .slice()
          .sort(function (a, b) { return (NAMES[a] || a).localeCompare(NAMES[b] || b); })
          .forEach(function (code) {
            var o = document.createElement('option');
            o.value = code;
            o.textContent = NAMES[code] || code;
            frag.appendChild(o);
          });
        var other = document.createElement('option');
        other.value = '__other__';
        other.textContent = 'My country is not listed';
        frag.appendChild(other);
        this.select.appendChild(frag);
      }

      toggle() {
        var open = this.panel.hidden;
        this.panel.hidden = !open;
        this.trigger.setAttribute('aria-expanded', String(open));
      }

      show() {
        var code = this.select.value;
        if (!code) {
          this.result.hidden = true;
          return;
        }

        this.result.hidden = false;
        this.result.classList.remove('is-available', 'is-unavailable');

        if (code === '__other__') {
          this.result.classList.add('is-unavailable');
          this.result.innerHTML =
            '<strong>We can\u2019t ship this item to your country yet.</strong>' +
            '<span>We\u2019re slowly adding more destinations. Contact us and we\u2019ll let you know when yours becomes available.</span>';
          return;
        }

        var name = NAMES[code] || code;
        this.result.classList.add('is-available');
        this.result.innerHTML =
          '<strong>Yes \u2014 we ship to ' + name + '</strong>' +
          '<span>Estimated transit: <strong>' + transitFor(code) + '</strong> once your parcel leaves the studio. ' +
          'That is in addition to the production time shown above.</span>';
      }
    });
  }
})();
